import { AnimationStateEnum } from 'enums/animation'
import { reportScopedError } from 'shared-utils/error'

export default defineNuxtPlugin(nuxtApp => {
  useHead({
    script: [
      {
        key: 'animation-bootstrap',
        tagPosition: 'head',
        innerHTML: ANIMATION_BOOTSTRAP_SCRIPT
      }
    ]
  })

  if (!import.meta.client) {
    return
  }

  const root = document.documentElement

  // Dropping the attribute restores opacity: decoration must never keep the content hidden.
  function revealEverything (error: Error): void {
    root.removeAttribute(ANIMATION_ROOT_ATTRIBUTE)
    reportScopedError('plugins::animation', 'Engine failed', error)
  }

  try {
    const isMotionReduced = window.matchMedia(ANIMATION_REDUCED_MOTION_QUERY).matches

    if (isMotionReduced) {
      root.removeAttribute(ANIMATION_ROOT_ATTRIBUTE)

      return
    }

    const engine = useAnimationEngine()

    nuxtApp.hook('app:suspense:resolve', () => {
      try {
        engine.start()
        // Set only once start() succeeded, so an earlier failure leaves the bootstrap failsafe in charge.
        root.setAttribute(ANIMATION_ROOT_ATTRIBUTE, AnimationStateEnum.READY)
      } catch (err) {
        revealEverything(err as Error)
      }
    })
  } catch (err) {
    revealEverything(err as Error)
  }
})
